/*
  Single source of truth for picking the unit price off a product summary.

  MIG products are created via the marketplace/create_product mutation
  which persists the listed price under `total_price` rather than the
  addon's expected `regular_price` field. The same fallback chain is
  applied server-side in:

    - modules/ecommerce/public/views/partials/carts/cart_item_details.liquid
    - modules/ecommerce/public/views/partials/order_items/create_order_items.liquid

  Keeping the React side aligned matters for the cart drawer + cart
  page + every checkout step's right-rail order summary, all of which
  use the cart_item.product join (not the server-computed totals).
*/

import type { ProductSummary } from '@/types/ecommerce'

export function resolveUnitPrice(product: ProductSummary | null | undefined): number {
  if (!product) return 0
  const fallback =
    (typeof product.total_price === 'number' && product.total_price > 0
      ? product.total_price
      : null) ??
    (typeof product.price === 'number' && product.price > 0 ? product.price : null) ??
    0

  if (product.is_on_sale) {
    if (typeof product.sale_price === 'number' && product.sale_price > 0) {
      return product.sale_price
    }
    return fallback
  }
  if (typeof product.regular_price === 'number' && product.regular_price > 0) {
    return product.regular_price
  }
  return fallback
}
